import * as React from 'react';
import Alert from 'reactstrap/lib/Alert';
import { Redirect } from 'react-router';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './PageNotFound.messages';

export interface PageNotFoundState {
  fireRedirect: boolean;
  visible: boolean;
}

export class PageNotFound extends React.Component<{}, PageNotFoundState> {
  
  state: PageNotFoundState = {
    fireRedirect: false,
    visible: true,
  };

  constructor(props: {}) {
    super(props);
    this.onDismiss = this.onDismiss.bind(this);
  }

  public render() {
    return (
      <div className="page-page-not-found fixed-bottom">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-4">
              <Alert color="danger" isOpen={this.state.visible} toggle={this.onDismiss}>
                <FormattedMessage {...MESSAGES.pageNotFoundMessage} />
              </Alert>
            </div>
          </div>
        </div>
        {this.state.fireRedirect && (<Redirect to="/" />)}
      </div>
    );
  }

  private onDismiss() {
    this.setState({ visible: false });
    setTimeout(() => this.setState({fireRedirect: true}), 1600);
  }
}
